export default function Segments() {
  return <div>Segments</div>;
}
